<template>
  <div>
    <div class="left">
      <ul>
        <li>
          <div>摄像头1</div>
        </li>
      </ul>
    </div>
    <div class="center">
      <div class="video-box" id="video-container"></div>
    </div>
    <div class="right">
      <div class="count-control">
        <div class="count-control-1">
          <div></div>
        </div>
      </div>
      <qiniuyun-control></qiniuyun-control>
    </div>
  </div>
</template>
<script>
import { QNRTPlayer } from "qn-rtplayer-web";
import qiniuyunApi from "@/api/qny_video";
import qiniuyunControl from '@/components/video/qiniuyunControl.vue'
import { setTimeout } from "timers";
export default {
  components: {
    qiniuyunControl
  },
  data () {
    return {
      player: null
    }
  },
  methods: {
    async playerinit() {
      this.player = new QNRTPlayer();
      this.player.init({
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        // objectFit: 'cover',
        // volumn: 0.6,
        // controls: true,
      });
      setTimeout(() => {
        this.streamUrl()
      }, 500);
    },
    async streamUrl() {
      await qiniuyunApi.getStreamUrl().then((res) => {
        if (res.code == 200) {
          this.startFlow(res.data)
        }
      });
    },
    async startFlow(url) {
      // url = 'webrtc://qvs-live.video.taiott.com:1240/taiott/31011500991320019082'
      await qiniuyunApi.startFlow().then((res) => {
        console.log('startFlow', res)
        if (res.code === 200) {
          this.player.play(
            url,
            document.getElementById("video-container")
          )
        }
      });
    },
    stopFlow() {
      qiniuyunApi.stopFlow().then((res) => {
        console.log('stopFlow', res)
        if (res.data.code === 1000) {
        }
      });
    },

  },
  mounted () {
    this.playerinit()
  },
  beforeDestroy () {
    this.player = null
    this.stopFlow()
  }
}
</script>

<style scoped>
.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
}
.num {
  height: 100%;
  width: 100%;
}
.left {
  position: fixed;
  top: 60px;
  left: 0px;
  bottom: 0px;
  width: 180px;
  background: #333;
  color:#fff;
}
.left .el-select {
  display: block;
  margin: 15px 0;
  padding: 0 15px;
  box-sizing: border-box;
}
.left .el-select + svg {
  display: none;
}
.left ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.left ul div {
  line-height:1.4;
  padding: 10px 20px;
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
}
.left ul div:hover {
  background: rgba(255, 255, 255, 0.1);
}

.left > ul {
  font-size: 16px;
  margin: 15px 0;
}
.center {
  position: fixed;
  top: 60px;
  left: 180px;
  right: 180px;
  bottom: 0;
}

.video-box{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #4C4B4B;
  box-sizing: border-box;
  border: 3px solid #353535;
}

.right {
  position: fixed;
  top: 60px;
  bottom: 0px;
  right: 0px;
  width: 180px;
  background: #333;
  color: #fff;
}

.video-preview-control-main {
    position: relative;
    padding-top: 100%;
    margin-top: 10px;
}
.circle {
    position: absolute;
    top: 15px;
    left: 15px;
    right: 15px;
    bottom: 15px;
    border-radius: 50%;
    border: 40px solid #3f475a;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    background: #1b1b1b;
}
.arrow {
    position: absolute;
    cursor: pointer;
    user-select: none;
}
.arrow:before {
    content: '';
    display: inline-block;
    position: absolute;
    border: 10px solid #ccdaeb;
    z-index: 1;
}
.arrow:hover:before {
    border: 10px solid #fff;
}
.arrow:active:before {
    border: 10px solid #666;
}
.arrow:after {
    content: '';
    display: inline-block;
    position: absolute;
    border: 10px solid transparent;
    z-index: 0;
}
.arrow-up {
    top: -40px;
    left: 0;
    width: 70px;
    height: 40px;
}
.arrow-up:before {
    top: 5px;
    left: 25px;
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
}
.arrow-up:after {
    top: 7px;
    left: 27px;
    border-bottom-color: rgba(0, 0, 0, 0.3);
}
.arrow-left {
    top: 0;
    left: -40px;
    width: 40px;
    height: 70px;
}
.arrow-left:before {
    top: 25px;
    left: 5px;
    border-top-color: transparent !important;
    border-left-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-left:after {
    top: 27px;
    left: 7px;
    border-right-color: rgba(0, 0, 0, 0.3);
}
.arrow-right {
    top: 0;
    left: 70px;
    width: 40px;
    height: 70px;
}
.arrow-right:before {
    top: 25px;
    left: 15px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-right:after {
    top: 27px;
    left: 17px;
    border-left-color: rgba(0, 0, 0, 0.3);
}
.arrow-down {
    top: 70px;
    left: 0;
    width: 72px;
    height: 40px;
}
.arrow-down:before {
    top: 15px;
    left: 25px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
}
.arrow-down:after {
    top: 17px;
    left: 27px;
    border-top-color: rgba(0, 0, 0, 0.3);
}
.camera {
    position: absolute;
    background: #cfdff1;
    color: #1b1b1b;
    width: 48px;
    height: 24px;
    line-height: 20px;
    text-align: center;
    left: 11px;
    box-sizing: border-box;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
}
.camera-up {
    top: 11px;
    border-top-left-radius: 48px;
    border-top-right-radius: 48px;
    border-bottom: 1px solid #1b1b1b;
}
.camera-down {
    bottom: 11px;
    border-bottom-left-radius: 48px;
    border-bottom-right-radius: 48px;
    border-top: 1px solid #1b1b1b;
}
.slider {
    overflow: hidden;
}
.slider > * {
    float: left;
}
.slider > span {
    display: inline-block;
    width: 30px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    vertical-align: top;
}
.slider .speed {
    width: 120px;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.autocomplete-wrapper {
  position: relative;
}
.autocomplete-wrapper .el-input input {
  border-radius: 18px;
  padding-right: 35px;
}
.autocomplete-search {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #333;
}
</style>